"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("./measures/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:layout": "section",
  "ui:title": "Vurdering og tiltak",
  "ui:options": {
    "collapsible": true,
    "sortable": true,
    "spacing": 0
  },
  "ui:buttons": [{
    "color": "primary",
    "icon": "add",
    "label": "Legg til bygningsdel"
  }],
  "items": {
    "ui:layout": "module",
    "ui:buttons": [{
      "type": "save",
      "icon": "check",
      "label": "Lagre og lukk"
    }],
    "ui:preview": {
      "select": {
        "title": "title",
        "documentType": "documentType",
        "description": "description"
      },

      prepare({
        formData,
        schema
      }) {
        const buildingPartId = formData.buildingPartId,
              stateId = formData.stateId,
              consequenceId = formData.consequenceId,
              measures = formData.measures;
        let title = "Uten tittel";

        if (buildingPartId && schema.properties.buildingPartId.enum && schema.properties.buildingPartId.enumNames) {
          const index = schema.properties.buildingPartId.enum.indexOf(buildingPartId);
          title = schema.properties.buildingPartId.enumNames[index] || index;
        }

        let metadata = [];
        stateId && metadata.push(stateId);
        consequenceId && metadata.push(consequenceId);
        measures && measures.length && metadata.push(measures.length + " tiltak");
        return {
          title: title,
          description: metadata.join(' – '),
          documentType: "Bygningsdel"
        };
      }

    },
    "ui:options": {
      "editable": true,
      "grid": true,
      "spacing": 2
    },
    "ui:fieldset": ["buildingPartId", "buildingDetails", "stateId", "consequenceId", "description", "measures"],
    "buildingPartId": {
      "ui:title": "Bygningsdel",
      "ui:placeholder": "Søk og velg bygningsdel",
      "ui:widget": "autocomplete"
    },
    "buildingDetails": {
      "ui:title": "Beskrivelse av bygningsdel",
      "ui:widget": "textarea"
    },
    "stateId": {
      "ui:title": "Tilstandsgrad",
      "ui:placeholder": "Velg tilstandsgrad",
      "ui:gridCols": 6
    },
    "consequenceId": {
      "ui:title": "Konsekvensgrad",
      "ui:placeholder": "Velg konsekvensgrad",
      "ui:gridCols": 6
    },
    "description": {
      "ui:title": "Beskrivelse av tilstand",
      "ui:widget": "textarea"
    },
    "measures": _uiSchema.default
  }
};
exports.default = _default;
module.exports = exports.default;